import React from 'react';
import './index.less'
import banner from '@public/images/banner.jpg';

const CommonBanner = (props) => {
  return (
    <div className="simple-banner">
      <div className="banner-content">
        <img src={banner} alt="招聘会横幅" className="banner-image" />
      </div>
    </div>
  );
}

export default CommonBanner
